export default __webpack_public_path__ + "static/ohnmacht-dee0fba1bd33b811a84bbb5d1053bbea.mp3";